module.exports = __webpack_public_path__ + "img/talentImg1@2x.9eecfc40.jpg";